import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect } from "react";
import { editTicket } from "../../api/tickets.api";
import styles from "../Overlay/Overlay.module.css"
import FieldForm from "../FieldForm";
import ButtonForm from "../ButtonForm";
import Overlay from "../Overlay";
import LabelRequired from "../LabelRequired";
import HeaderForm from "../HeaderForm";


function FormTicketEdit({ setIsOpen, thisTicket }) {

    useEffect(() => {
        if (thisTicket?.dataPrevisao) {
            const partes = thisTicket.dataPrevisao.split("/");
            setDataPrevista(`${partes[2]}-${partes[1]}-${partes[0]}`);
        }

    }, []);

    const [custo, setCusto] = useState(
        thisTicket?.custo != undefined && thisTicket?.custo != null
            ? String(thisTicket.custo)
            : ""
    );
    const [oficina, setOficina] = useState(thisTicket.oficina != "----------" ? thisTicket.oficina : "")
    const [dataPrevista, setDataPrevista] = useState("")
    const [descricao, setDescricao] = useState(thisTicket.descricao)
    const [carId, setCarId] = useState(thisTicket.car.id)


    const formatCurrency = (rawValue) => {

        let digits = rawValue.replace(/\D/g, "");


        if (!digits) return "";

        const amount = (Number(digits) / 100).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true
        });

        return amount;
    };

    const handleChange = (e) => {
        const rawValue = e.target.value;
        const formattedValue = formatCurrency(rawValue);
        setCusto(formattedValue);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const valueForBackend = String(custo).replace(/,/g, '');

        const dataFormatada = `${dataPrevista}T17:00:00`

        const dataAberturaPartes = thisTicket.dataAbertura.split("/")
        const dataAberturaFormatada = `${dataAberturaPartes[2]}-${dataAberturaPartes[1]}-${dataAberturaPartes[0]}T00:00:00`

        const ticketData = {
            Id: thisTicket.id,
            Custo: valueForBackend,
            DataPrevisao: dataFormatada,
            Oficina: oficina,
            Codigo: thisTicket.codigo,
            CarId: +carId === 0 ? null : +carId,
            Status: thisTicket.status != "Finalizado" ? thisTicket.status : "Reaberto",
            DataAbertura: dataAberturaFormatada,
            Descricao: descricao,
            ChecklistId: thisTicket.checklistId != null ? thisTicket.checklistId : null,
        }

        await editTicket(ticketData)
            .then(() => {
                setIsOpen(false);
                return toast.success("Ticket editado!")
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }


    return (
        <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm
                    title="Editar Ticket"
                    close={() => setIsOpen(false)}
                />
                <div className={styles.customField}>
                    <label>ID Carro</label>
                    <input
                        className={styles.inputCusto}
                        type="number"
                        value={thisTicket.car.id}
                        readOnly
                    />
                </div>
                <div className={styles.customField}>
                    <label>Data de Abertura</label>
                    <input
                        className={styles.inputCusto}
                        type="text"
                        value={thisTicket.dataAbertura}
                        readOnly
                    />
                </div>
                <FieldForm
                    type="text"
                    placeholder="Zé Auto-Peças"
                    field="Oficina"
                    setThing={setOficina}
                    value={oficina}
                />
                <div className={styles.customField}>
                    <label>Custo</label>
                    <input
                        className={styles.inputCusto}
                        type="text"
                        value={custo}
                        onChange={handleChange}
                        placeholder="0.00"
                    />
                </div>

                <FieldForm
                    type="date"
                    placeholder="01/02/2026"
                    field="Data Prevista"
                    setThing={setDataPrevista}
                    value={dataPrevista}
                    readOnly
                />
                <div className={styles.textarea}>
                    <LabelRequired>Descrição</LabelRequired>
                    <textarea onChange={(e) => setDescricao(e.target.value)} placeholder="Descreva o problema..." >{descricao}</textarea>
                </div>

                <ButtonForm>Editar Ticket</ButtonForm>
            </form >

        </Overlay>
    )
}

export default FormTicketEdit